// extracted by mini-css-extract-plugin
export default {"root":"ExpirationDetails_root__njJIh","label":"ExpirationDetails_label__Yap3F"};